import { Check } from "lucide-react"
import type { PropsWithChildren } from "react"

import * as styles from "./breadcrumb-item.styled"

type BreadcrumbItemProps = PropsWithChildren<
  styles.BreadcrumbItemVariants & {
    stepNumber: number
    isActive: boolean
  }
>

export const BreadcrumbItem = ({
  children,
  variant,
  stepNumber,
  isActive,
}: BreadcrumbItemProps) => {
  const isStepDone = variant === "default" && !isActive

  return (
    <div className={styles.baseBreadcrumbItemClassName({ variant, isActive })}>
      <span className={styles.text}>
        <span className={styles.desktopText(variant, isActive)}>{children}</span>
        <span className={styles.mobileText(variant, isActive)}>
          {isStepDone ? <Check className="w-5" /> : `0${stepNumber}`}
        </span>
      </span>
    </div>
  )
}
